import { render, staticRenderFns } from "./businessBox.vue?vue&type=template&id=8bd40b44&scoped=true"
import script from "./businessBox.vue?vue&type=script&lang=js"
export * from "./businessBox.vue?vue&type=script&lang=js"
import style0 from "./businessBox.vue?vue&type=style&index=0&id=8bd40b44&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd40b44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bd40b44')) {
      api.createRecord('8bd40b44', component.options)
    } else {
      api.reload('8bd40b44', component.options)
    }
    module.hot.accept("./businessBox.vue?vue&type=template&id=8bd40b44&scoped=true", function () {
      api.rerender('8bd40b44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/businessBox.vue"
export default component.exports